// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"custom_wrapper__24i_1"};